import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { brandService } from '../../services/brandService';

export const useGetBrandDetail = id => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.brand.detail_by_id, id],
    queryFn: () =>
      brandService.brandDetail(id).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
